// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2FJg5","colMin":"styles_colMin__1KiH3","colCheckbox":"styles_colCheckbox__3vsDA"};